import Dexie from "dexie";
const SECURE_DATAFLOW_DB_NAME = "secureDataflowLocalStorageDb";
const db = new Dexie(SECURE_DATAFLOW_DB_NAME);

export default {
  init() {
    db.version(1).stores({
      vessel: "id, vessel_info, maneuvering_origin_id, engine_origin_id",
      channel_master : "channel_id, info",
      channels_data: "channel_id, *point_data"
    });

    db.version(2).stores({
      vessel: "id, vessel_info, maneuvering_origin_id, engine_origin_id",
      channel_master : "channel_id, info",
      channels_data: "channel_id, *point_data",
      map: "map_id, zoom_level",
      settings: "setting_id, is_display_other_vessels, on_alert_summary_notification, on_vessel_auto_tracking, track_display_interval, track_history_interval"
    });
  },

  getInstance() {
    return db;
  },

  isExists() {
    return Dexie.exists(SECURE_DATAFLOW_DB_NAME);
  }
};
